import {useAuthAxios} from '@hooks/useAuthAxios';
import {noop} from '@utils/constants';

export const TRACK_MODELS = {
    rests: 'rests',
    warehouses: 'warehouses',
} as const;

export const TRACK_EVENTS = {
    /** Поиск товаров в каталоге остатков */
    productSearch: 'product_search',
    /** Открытие модалки остатков по товару */
    productRestsView: 'product_rests_view',
    /** Карточка поставщика в поиске складов */
    supplierSearchCard: 'supplier_search_card',
    /** Страница поставщика (/supplier/:id) */
    supplierPageView: 'supplier_page_view',
    /** Клик по типу товара в карточке поставщика */
    supplierProductTypeClick: 'supplier_product_type_click',
    /** Клик «Показать телефон» в модалке поставщика */
    supplierPhoneReveal: 'supplier_phone_reveal',
    /** Переход на сайт поставщика из модалки */
    supplierWebsiteClick: 'supplier_website_click',
    /** Клик по кнопке «Продать на» (RoboTyre) в хедере */
    robotyreClick: 'robotyre_click',
} as const;

export type TrackEvent = (typeof TRACK_EVENTS)[keyof typeof TRACK_EVENTS];

export type TrackParams = {
    event: TrackEvent;
    /** Не передаётся для robotyre_click */
    model?: keyof typeof TRACK_MODELS;
    model_id?: number | string | bigint;
    ref_url?: string | null;
};

export const useTrack = () => {
    const axios = useAuthAxios();
    return (params: TrackParams) => {
        let sid = localStorage.getItem('session_id');
        if (!sid) {
            sid = (crypto.randomUUID?.() ?? (Date.now().toString(36) + Math.random().toString(36).slice(2)));
            localStorage.setItem('session_id', sid);
        }

        axios.post('/track', {
            event: params.event,
            ...(params.model ? {model: params.model} : {}),
            model_id: params.model_id,
            url: window.location.href,
            ref_url: params.ref_url,
            session_id: sid,
        }).catch(noop);
    };
};
